/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconCalculator = (props) => (
  <SVG
    data-cy="calculator"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.501 19.493"
    {...props}
  >
    <g id="calculator" transform="translate(0 -.099)">
      <g id="Group_18" data-name="Group 18" transform="translate(0 .099)">
        <g id="Group_17" data-name="Group 17">
          <path
            id="Path_45"
            d="M0 .1v19.492h19.47L19.5.1zm9.181 18.35H1.143v-8.183h8.038zm0-9.326H1.143V1.242h8.038zm9.151 9.326h-8.008v-8.183h8.035zm.027-9.326h-8.035V1.242h8.035z"
            className="cls-1"
            data-name="Path 45"
            transform="translate(0 -.099)"
          />
        </g>
      </g>
      <g id="Group_20" data-name="Group 20" transform="translate(12.345 3.263)">
        <g id="Group_19" data-name="Group 19">
          <path
            id="Path_46"
            d="M326.669 84.576v-1.409h-1.143v1.409h-1.409v1.143h1.409v1.409h1.143v-1.409h1.409v-1.143z"
            className="cls-1"
            data-name="Path 46"
            transform="translate(-324.117 -83.167)"
          />
        </g>
      </g>
      <g
        id="Group_22"
        data-name="Group 22"
        transform="translate(12.345 12.665)"
      >
        <g id="Group_21" data-name="Group 21">
          <path
            id="Rectangle_47"
            d="M0 0h3.961v1.143H0z"
            className="cls-1"
            data-name="Rectangle 47"
          />
        </g>
      </g>
      <g id="Group_24" data-name="Group 24" transform="translate(12.345 14.57)">
        <g id="Group_23" data-name="Group 23">
          <path
            id="Rectangle_48"
            d="M0 0h3.961v1.143H0z"
            className="cls-1"
            data-name="Rectangle 48"
          />
        </g>
      </g>
      <g id="Group_26" data-name="Group 26" transform="translate(3.081 12.209)">
        <g id="Group_25" data-name="Group 25">
          <path
            id="Path_47"
            d="M84.856 318.852l-.808-.808-1.172 1.172-1.176-1.172-.808.808 1.172 1.172L80.9 321.2l.8.8 1.172-1.172L84.048 322l.808-.808-1.172-1.172z"
            className="cls-1"
            data-name="Path 47"
            transform="translate(-80.896 -318.044)"
          />
        </g>
      </g>
      <g id="Group_28" data-name="Group 28" transform="translate(3.14 4.672)">
        <g id="Group_27" data-name="Group 27">
          <path
            id="Rectangle_49"
            d="M0 0h3.961v1.143H0z"
            className="cls-1"
            data-name="Rectangle 49"
          />
        </g>
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconCalculator)
